import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { CHART_MARGIN, AXIS_LINE, TOOLTIP_STYLE, inrTick, inrValue } from "./chartTheme";

export function CashflowSection({ cashflow }) {
  return (
    <section className="border border-[#D8D4C7] bg-white p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#6C7565]">Twelve months</div>
          <h3 className="font-serif text-3xl tracking-tight">Cashflow.</h3>
        </div>
      </div>
      <div className="h-80" data-testid="chart-cashflow">
        <ResponsiveContainer>
          <AreaChart data={cashflow} margin={CHART_MARGIN}>
            <CartesianGrid stroke="#EAE7DD" vertical={false} />
            <XAxis dataKey="month" stroke="#6C7565" fontSize={10} tickLine={false} axisLine={AXIS_LINE} />
            <YAxis stroke="#6C7565" fontSize={10} tickLine={false} axisLine={AXIS_LINE} tickFormatter={inrTick} />
            <Tooltip contentStyle={TOOLTIP_STYLE} formatter={inrValue} />
            <defs>
              <linearGradient id="incFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2E6F40" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#2E6F40" stopOpacity={0.02} />
              </linearGradient>
              <linearGradient id="expFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#D94F3D" stopOpacity={0.3} />
                <stop offset="100%" stopColor="#D94F3D" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <Area type="monotone" dataKey="income" stroke="#2E6F40" strokeWidth={2} fill="url(#incFill)" />
            <Area type="monotone" dataKey="expense" stroke="#D94F3D" strokeWidth={2} fill="url(#expFill)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
